// src/components/common/ActionFeedback.jsx
import { CheckCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

/**
 * Action feedback banner for success/error messages
 * Works with useActionFeedback hook
 */
const ActionFeedback = ({
    feedback,
    onDismiss,
    className = ''
}) => {
    if (!feedback) return null;

    const { message, isError } = feedback;

    return (
        <div className={`
 ${isError ? 'bg-red-50 border-red-200' : 'bg-green-50 border-green-200'}
 border p-4 flex items-center justify-between
 ${className}
 `}>
            <div className="flex items-center">
                {isError ? (
                    <XCircleIcon className="h-5 w-5 text-red-700 mr-3" />
                ) : (
                    <CheckCircleIcon className="h-5 w-5 text-green-700 mr-3" />
                )}
                <p className={isError ? 'text-red-700' : 'text-green-700'}>
                    {message}
                </p>
            </div>
            {onDismiss && (
                <button
                    onClick={onDismiss}
                    className={`
 p-1 hover:bg-opacity-20
 ${isError ? 'hover:bg-red-400' : 'hover:bg-green-400'}
 `}
                >
                    <XMarkIcon className={`h-4 w-4 ${isError ? 'text-red-700' : 'text-green-700'}`} />
                </button>
            )}
        </div>
    );
};

export default ActionFeedback;
